// BookFilterContext.js
import { createContext, useContext, useState } from "react";
import useBooksFilters from "./useBooksFilters";

const BookFilterContext = createContext(null);

export const BookFilterProvider = ({ children }) => {
	const filters = useBooksFilters();

	const formValues = filters?.allSearchParams?.reduce((acc, key) => {
		acc[key] = "";
		return acc;
	}, {});

	const [filterValues, setFilterValues] = useState(formValues);

	const contextValue = {
		filters,
		filterValues,
		setFilterValues,
	};

	return (
		<BookFilterContext.Provider value={contextValue}>
			{children}
		</BookFilterContext.Provider>
	);
};

export const useBookFilterContext = () => {
	const context = useContext(BookFilterContext);
	if (!context) {
		throw new Error(
			"useBookFilterContext must be used within a BookFilterProvider"
		);
	}
	return context;
};
